export const CHAT_DIALOG_ID = 'synapse-chat-dialog'

export const CHAT_START_CHAT_ID = 'synapse-chat-start-chat'

export const CHAT_HOME_SEARCH_PANEL_ID = 'synapse-chat-home-search-panel'

export const DISABLE_SELECT_ID = [CHAT_DIALOG_ID, CHAT_START_CHAT_ID, CHAT_HOME_SEARCH_PANEL_ID]
